import type { ProductSustainabilityScore } from '../../../common/models/props/itemTeaserProps';

type Risk = NonNullable<ProductSustainabilityScore['sustainabilityCategory']>;

const iconTemplates: Record<Risk, string> = {
    low: '/Assets/Images/Lights/green.svg',
    medium: '/Assets/Images/Lights/yellow.svg',
    high: '/Assets/Images/Lights/red.svg',
};

const getIcon = (risk: Risk) => {
    return iconTemplates[risk];
};

export const getLights = (productScores: ProductSustainabilityScore[]) => {
    const lights = productScores
        .map((ps) => {
            if (ps.sustainabilityCategory && ps.sustainabilityScore) {
                return {
                    id: ps.paramId,
                    name: ps.param,
                    sustainabilityScore: ps.sustainabilityScore,
                    url: getIcon(ps.sustainabilityCategory),
                    risk: ps.sustainabilityCategory,
                };
            }

            return undefined;
        })
        .filter(Boolean)
        .sort((a, b) => a.sustainabilityScore - b.sustainabilityScore);

    return lights;
};

export const getSustainabilityA11yLabelFromLights = (lights: ReturnType<typeof getLights>) => {
    const risks = lights.reduce(
        (curr, next) => {
            switch (next.risk) {
                case 'low':
                    return { ...curr, lowRisk: curr.lowRisk + 1 };
                case 'medium':
                    return { ...curr, mediumRisk: curr.mediumRisk + 1 };
                case 'high':
                    return { ...curr, highRisk: curr.highRisk + 1 };
                default:
                    return curr;
            }
        },
        { lowRisk: 0, mediumRisk: 0, highRisk: 0 },
    );

    let label = '';

    if (risks.lowRisk > 0) {
        label += ` Låg risk för påverkan: ${risks.lowRisk} ${risks.lowRisk === 1 ? 'område' : 'områden'}.`;
    }

    if (risks.mediumRisk > 0) {
        label += ` Medel risk för påverkan: ${risks.mediumRisk} ${risks.mediumRisk === 1 ? 'område' : 'områden'}.`;
    }

    if (risks.highRisk > 0) {
        label += ` Hög risk för påverkan: ${risks.highRisk} ${risks.highRisk === 1 ? 'område' : 'områden'}.`;
    }

    label = label.trim();
    return label;
};

export const getSustainabilityA11yLabelFromScores = (
    productScores: ProductSustainabilityScore[],
) => {
    const lights = getLights(productScores);
    const label = getSustainabilityA11yLabelFromLights(lights);
    return label;
};
